// extracted by css-extract-rspack-plugin
export default {"blink":"oosZ7uAxsq0FbJjR"};